import { render, staticRenderFns } from "./ClassroomDetailTabFilter.vue?vue&type=template&id=4d9232c4&scoped=true"
import script from "./ClassroomDetailTabFilter.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabFilter.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabFilter.vue?vue&type=style&index=0&id=4d9232c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9232c4",
  null
  
)

export default component.exports